import { Injectable } from '@angular/core';
import {
  ONE_GB_SIZE,
  ONE_KB_SIZE,
  ONE_MB_SIZE,
} from '../../../document-data/document-data.data';

@Injectable({
  providedIn: 'root',
})
export class FileSizeService {
  constructor() {}

  getReadableSize(size: number, fractionDigit = 0): string {
    if (size >= ONE_GB_SIZE) {
      return (size / ONE_GB_SIZE).toFixed(fractionDigit) + 'GB';
    } else if (size >= ONE_MB_SIZE) {
      return (size / ONE_MB_SIZE).toFixed(fractionDigit) + 'MB';
    } else if (size >= ONE_KB_SIZE) {
      // fraction digit is 0 when file size is > 1KB by default (can be changed if necessary)
      return (size / ONE_KB_SIZE).toFixed() + 'KB';
    } else {
      return (size / ONE_KB_SIZE).toFixed(fractionDigit) + 'KB';
    }
  }
}
